import React, { useMemo } from 'react'

import { Grid } from "@material-ui/core";

const project = require('EurestoConfig/project.config')
import User from 'EurestoClass/User'

export default React.memo(props => {

    const token = useMemo(() => localStorage.getItem('token'), [])

    return <iframe style={{ width: '100%', height: User.CalculHeight.getHeightWanted() }}
        frameBorder={"0"}
        src={`${project.api.replace(5000, 3000).replace('api', 'cloud')}configuration/gestion?navigation=off&token=${token}#Critère`} sandbox />
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Gestion/Critere/index.js